module.exports = __webpack_public_path__ + "media/assets/services_manager/arrow-up-db1605cb3388f02f3cc014c5f4920e6d5f1a26149e1c3b4becd35a0084a4c716.svg";